<div class="old-footer-bar">
    <div class="old-footer-bar--part">
        <ng-content select="[footerContentLeft]"></ng-content>
    </div>

    <div class="old-footer-bar--part">
        <ng-content select="[footerContentRight]"></ng-content>
    </div>
</div>
